//Include Both Helper File with needed methods
import { getFirebaseBackend } from '../../../helpers/firebase_helper';
import { postLogin, postAzureLogin, } from '../../../helpers/auth/backend_helper';
import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag, loginBegin, } from './reducer';
import { setAuthorization } from '../../../helpers/api_helper';
import globalRouter from '../../../Routes/globalRouter';
import {
	setRequireInitRedirect,
	setUrlToRedirect as setUrlToRedirectReducer
} from '../../settings/reducer';
import { setItemRoleDetail } from '../roles/reducer';
import { constants } from '../../../config';
import { getProfile } from '../profile/thunk';

export const loginUser = (user, navigate) => async dispatch => {
	try {
		let response;
		dispatch(loginBegin());
		response = postLogin({
			username: user.email,
			password: user.password,
		});

		var data = await response; 

		if (data) {
			// sessionStorage.setItem('authUser', JSON.stringify(data));
			window.localStorage.setItem('authUser', JSON.stringify(data));
			setAuthorization(data.access_token);
			dispatch(loginSuccess(data));
			dispatch(setItemRoleDetail([]))
			dispatch(setRequireInitRedirect(true));

			if (data.privacy_policy) {
				navigate('/');
			} else {
				navigate('/privacy-policy');
			}
		}
	} catch (error) {
		// dispatch(apiError(error));
		throw error; // Lanza la excepción para que pueda ser capturada por el formulario
	}
};

export const logoutUser = () => async dispatch => {
	try {
		localStorage.removeItem('authUser');
		let fireBaseBackend = getFirebaseBackend();
		if (constants.REACT_APP_DEFAULTAUTH === 'firebase') {
			const response = fireBaseBackend.logout;
			dispatch(logoutUserSuccess(response));
		} else {
			dispatch(logoutUserSuccess(true));
		}
	} catch (error) {
		dispatch(apiError(error));
	}
};

export const redirectToLogout = () => async dispatch => {
	dispatch(setUrlToRedirectReducer(null));
	globalRouter.navigate('/logout');
};

export const redirectToMenuUrl = (url) => async dispatch => {
	dispatch(setUrlToRedirectReducer(url));
	globalRouter.navigate(url);
};

export const setUrlToRedirect = (url) => async dispatch => {
	dispatch(setUrlToRedirectReducer(url));
};

export const socialLogin = (type, history) => async dispatch => {
	try {
		let response;

		if (constants.REACT_APP_DEFAULTAUTH === 'firebase') {
			const fireBaseBackend = getFirebaseBackend();
			response = fireBaseBackend.socialLoginUser(type);
		}
		//  else {
		//   response = postSocialLogin(data);
		// }

		const socialdata = await response;
		if (socialdata) {
			localStorage.setItem('authUser', JSON.stringify(response));
			dispatch(loginSuccess(response));
			history('/dashboard');
		}
	} catch (error) {
		dispatch(apiError(error));
	}
};

export const azureLogin = code => async dispatch => {
	try {
		let response;
		response = postAzureLogin(code);
		return await response;
	} catch (error) {
		dispatch(apiError(error));
	}
};

export const resetLoginFlag = () => async dispatch => {
	try {
		const response = dispatch(reset_login_flag());
		return response;
	} catch (error) {
		dispatch(apiError(error));
	}
};
